import {
  BanquetFeatureFlagsProvider,
  useFlags as useOriginalFlags
} from '@toasttab/banquet-feature-flags'
import { BanquetFeatureFlagsProviderProps } from '@toasttab/banquet-feature-flags/dist/BanquetFeatureFlagsProvider/BanquetFeatureFlagsProvider'
import React, { createContext, useContext } from 'react'

interface FeatureFlagContextType {
  isTestMode: boolean
  mockFlags?: Record<string, boolean>
}

const FeatureFlagContext = createContext<FeatureFlagContextType>({
  isTestMode: false
})

export const useIsTestMode = () => {
  const { isTestMode } = useContext(FeatureFlagContext)
  return isTestMode
}

export const useFlags = () => {
  const { isTestMode, mockFlags } = useContext(FeatureFlagContext)
  const originalFlags = useOriginalFlags()

  if (isTestMode && mockFlags) {
    return mockFlags
  }

  return originalFlags
}

export interface FeatureFlagProviderProps
  extends BanquetFeatureFlagsProviderProps {
  isTestMode?: boolean
  restaurantGuid: string
  mockFlags?: Record<string, boolean>
}

export const FeatureFlagProvider = ({
  isTestMode = false,
  restaurantGuid,
  mockFlags,
  children
}: FeatureFlagProviderProps) => {
  return (
    <FeatureFlagContext.Provider value={{ isTestMode, mockFlags }}>
      <BanquetFeatureFlagsProvider
        user={{ key: restaurantGuid }}
        deferInitialization
      >
        {children}
      </BanquetFeatureFlagsProvider>
    </FeatureFlagContext.Provider>
  )
}
